import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01d3e52b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row g-3 container-fluid" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "container p-0" }
const _hoisted_4 = { class: "row row-cols-1 row-cols-md-3 g-4" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  class: "img-container",
  style: {"overflow":"hidden"}
}
const _hoisted_7 = { class: "d-flex justify-content-between p-3 align-items-center" }
const _hoisted_8 = { class: "card-title m-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Projetos")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col",
            key: project.id
          }, [
            _createElementVNode("div", {
              class: "card",
              onClick: ($event: any) => (_ctx.sendToListaTickets(project.id)),
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_image, {
                  src: project.url,
                  style: {"width":"100%","height":"161px"},
                  class: "rounded-top img-banner",
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h5", _hoisted_8, _toDisplayString(project.name), 1),
                _hoisted_9
              ])
            ], 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ])
  ]))
}